/**
 * FAQ 5013 — KUK frequently asked questions.
 *
 * A single-open accordion under a ruled heading, with a Contact Us CTA beneath
 * it. Ported from kuk-campus-portal's `components/organisms/FAQs.tsx`.
 *
 * Questions live in `faq_item` rows under `faq_category`, so this uses Form_3's
 * nested category/item editor. The category and item field configs are shared
 * with FAQ 1033 rather than duplicated — the child tables are identical, and one
 * copy means the two variants' editors cannot drift apart.
 *
 * COLUMN MAPPING — `faq` has no CTA columns, so the Contact Us button borrows
 * `title_1` (label), `title_2` (link) and `gradient_color_3` / `gradient_color_4`
 * (its colours). Documented here because those names say nothing about the CTA.
 */

import { FAQ_1033_CONSTANTS } from "./faq_1033";


export const FAQ_5013_CONSTANTS = {
  FAQ_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "FAQs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "FAQs",
      required: false,
      defaultValue: "FAQs",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#031F44",
      required: false,
      defaultValue: "#031F44",
    },
    {
      fieldName: "section_color",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "section_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_color",
      label: "Open row fill (below 768px)",
      value: "#F4F5F7",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F4F5F7",
      description: "The reference tints an open row on mobile so the accordion reads as cards.",
      required: false,
      defaultValue: "#F4F5F7",
    },
    {
      fieldName: "accordion_answer_surface_bg",
      label: "Open row fill (768px and up)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      description: "White in the reference, so open rows read as plain rows on desktop.",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "accordion_item_border_color",
      label: "Row separator",
      value: "rgba(3, 31, 68, 0.12)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(3, 31, 68, 0.12)",
      required: false,
      defaultValue: "rgba(3, 31, 68, 0.12)",
    },
    {
      fieldName: "gradient_color_1",
      label: "Question colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#031F44",
      required: false,
      defaultValue: "#031F44",
    },
    {
      fieldName: "gradient_color_2",
      label: "Answer colour",
      value: "rgba(3, 31, 68, 0.50)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(3, 31, 68, 0.50)",
      required: false,
      defaultValue: "rgba(3, 31, 68, 0.50)",
    },
    {
      fieldName: "title_1",
      label: "CTA text",
      value: "Contact Us",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Contact Us",
      description: "Hidden below 768px, as in the reference. Leave empty to hide it entirely.",
      required: false,
      defaultValue: "Contact Us",
    },
    {
      fieldName: "title_2",
      label: "CTA link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://…",
      description: "Left empty, the CTA opens the lead form popup instead.",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_3",
      label: "CTA background colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "gradient_color_4",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  /** Shared with FAQ 1033 — same `faq_category` / `faq_item` tables. */
  CATEGORY_FIELDS_CONFIG: FAQ_1033_CONSTANTS.CATEGORY_FIELDS_CONFIG,
  FAQ_TABLE_FIELDS_CONFIG: FAQ_1033_CONSTANTS.FAQ_TABLE_FIELDS_CONFIG,
  DEFAULT_ROW: FAQ_1033_CONSTANTS.DEFAULT_ROW,
};
